import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChatboxserviceService } from '../service/chatboxservice.service';


@Component({
  selector: 'ngx-chatboxcomp',
  templateUrl: './chatboxcomp.component.html',
  styleUrls: ['./chatboxcomp.component.scss']
})
export class ChatboxcompComponent implements OnInit {


  roomId = 'room-apt-101';
  message = '';
  messages: any[] = [];
  role = localStorage.getItem('userFlag');

  constructor(private chat: ChatboxserviceService) {}

  async ngOnInit() {
    await this.chat.joinRoom(this.roomId);

    this.chat.listen(this.roomId).subscribe(msgs => {
      this.messages = msgs;
    });
  }

  send() {
    if (!this.message.trim()) return;
    this.chat.sendMessage(this.roomId, this.message);
    this.message = '';
  }

  scrollBottom() {
    const el = document.getElementById('chatBody');
    if (el) el.scrollTop = el.scrollHeight;
  }
}
